import { FULL_ROTATION_RADIANS } from '@/helpers/angleConstants';
import { NumUtils } from '@/modules/common/utils';

/**
 * Rotates a constellation angle by the given delta, keeping result in circular range [0, 2π).
 */
export const rotateConstellation = (angle: number, angleDelta: number): number =>
  NumUtils.restrictToCircularRange(angle + angleDelta, FULL_ROTATION_RADIANS);
